import { buildCzmlPackage } from './build_czml_package'

export const useEfbLayer = (controller, { cesiumViewer, buttonGroup }) => {
  const efbDataSource = new Cesium.CzmlDataSource('efb-data-source')

  cesiumViewer.dataSources.add(efbDataSource)

  const setupLayerToggle = () => {
    const efbToggleInput = $('<input/>', { type: 'checkbox', id: 'efb-layer-toggle', class: 'mr-2', checked: true })
    const efbToggleLabel = $('<label/>', { class: 'cesium-button efb-toggle-button', text: 'EFB Aircraft' })

    efbToggleLabel.prepend(efbToggleInput)
    buttonGroup.append(efbToggleLabel)

    efbToggleInput.on('change', (e) => {
      if (e.target.checked) {
        controller.showEfbLayer()
      } else {
        controller.hideEfbLayer()
      }
    })
  }

  Object.assign(controller, {
    showEfbLayer () {
      efbDataSource.show = true
    },

    hideEfbLayer () {
      efbDataSource.show = false
    },

    updateEfb ({ detail }) {
      efbDataSource.process(buildCzmlPackage(detail, [20, 100, 255, 220], [0, 200, 255, 188]))
    }
  })

  setupLayerToggle()
}
